import { jsx } from "react/jsx-runtime";
const Info = ({ className, color: colorProp = '#181B32', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    return /*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            d: "M11 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 3a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0v-5Zm1 9c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8Zm0-18C6.477 2 2 6.477 2 12s4.477 10 10 10c5.522 0 10-4.477 10-10S17.522 2 12 2Z",
            fill: color
        })
    });
};
const outline_Info = Info;
export default outline_Info;
